import { getResourcePathByResourceKind, ResourceKind } from 'lib/enum/resource-kind.enum';

export type Iri = string;

export const getUuidFromIri = (uri: Iri): string => uri.substring(uri.lastIndexOf('/') + 1);

export const getUuidFromNullableItem = (item: Iri | null): string | null => item && getUuidFromIri(item);

export const generateIri = (resourceKind: ResourceKind, uuid: string | number): string => {
    const resourcePath = getResourcePathByResourceKind(resourceKind);
    return resourcePath ? `/api${resourcePath}/${uuid}` : '';
};
